__webpack_require__.p = "https://static.kreditpintar.net/k8s-kp-website/_next/";